"use strict";

angular.module('rmToolbar', []);

require('./config');
require('./controller');
